import React from "react"
import TimeRegister from "../../views/timeRegister/TimeRegister.view"
import { AppRoutes } from "../../consts/appRoutes.consts"
import { VACATION_PERIOD_NAVIGATOR_MODES } from "../../consts/modules/vacations.consts"
import Home from "../../views/home/Home.view"
import IndividualReport from "../../views/individualReport/IndividualReport.view"
import ChangeLog from "../../views/changeLog/ChangeLog.view"
import PendingTasks from "../../views/pendingTasks/PendingTasks.view"
import Vacations from "../../views/vacations/Vacations.view"

export const TEAM_MEMBER_ROUTES = [
  {
    path: AppRoutes.home.index,
    element: <Home />,
  },
  {
    path: AppRoutes.registroTiempos.index,
    element: <TimeRegister />,
  },
  {
    path: AppRoutes.reporteIndividual.index,
    element: <IndividualReport />,
  },
  {
    path: AppRoutes.reporteIndividual.redirect,
    element: <IndividualReport />,
  },
  {
    path: AppRoutes.changeLog.index,
    element: <ChangeLog />,
  },
  {
    path: AppRoutes.listaPendientes.index,
    element: <PendingTasks />,
  },
  {
    path: AppRoutes.vacaciones.index,
    element: <Vacations mode={VACATION_PERIOD_NAVIGATOR_MODES.PERIOD} />,
  },
  {
    path: AppRoutes.vacaciones.historialVacacionesMiembroEquipo,
    element: <Vacations mode={VACATION_PERIOD_NAVIGATOR_MODES.HISTORY_TEAM_MEMBER} />,
  }
]
